import {
  alpha,
  Autocomplete,
  Box,
  Grid,
  Skeleton,
  styled,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import InfoPopover from "../../Components/Common/poper/InfoPopover";
import { useEffect, useRef, useState } from "react";
import DataTable from "../../Components/Common/datatable/DataTable";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import ButtonComponent from "../../Components/Common/button/Button";
import { setBottlerData } from "../../redux/entitySlice";
import ApiService from "../../utils/fetch";
import { MessagePopup } from "../../Components/Common/messagePopup/MessagePopup";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveDataElement,
  setSelectedBottler,
} from "../../redux/userSlice";
import { useSupport } from "../../context/SupportContext";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
//check
const BlackWhiteSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#000",
    "&:hover": {
      backgroundColor: alpha("#000", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase": {
    color: "#ccc",
    "&:hover": {
      backgroundColor: alpha("#000", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#ccc",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#000",
  },
}));

const DEFAULT_ONBOARDING_TAB = "Bottler Concentrate Forecast";
const DATA_ELEMENTS_OPTIONS = [
  "Bottler Concentrate Forecast",
  "Bottler Market Forecast",
  "FG Inventory",
  "Bottler Business Plan",
  "Concentrate Inventory",
  "Production Requirement",
];

function BottlerOnBoarding() {
  const gridRef = useRef(null);
  const mfGridRef = useRef(null);
  const fgGridRef = useRef(null);
  const bpGridRef = useRef(null);
  const ciGridRef = useRef(null);
  const prGridRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();
  const activeDataElement = useSelector(
    (state) => state.user.activeDataElement,
  );
  let { combinationDetails, setCombinationDetails } = useSupport();
  const [selectedRows, setSelectedRows] = useState([]);

  const [BottlerData, setBottlerData] = useState([]);
  const [bottlerLoading, setBottlerLoading] = useState(false);

  const [marketForecastData, setMarketForecastData] = useState([]);
  const [marketForecastLoading, setMarketForecastLoading] = useState(false);

  const [fgInventoryData, setFGInventoryData] = useState([]);
  const [fgInventoryLoading, setFGInventoryLoading] = useState(false);

  const [businessPlanData, setBusinessPlanData] = useState([]);
  const [businessPlanLoading, setBusinessPlanLoading] = useState(false);

  const [concentrateInventoryData, setConcentrateInventoryData] = useState([]);
  const [concentrateInventoryLoading, setConcentrateInventoryLoading] =
    useState(false);

  const [productionRequirementData, setProductionRequirementData] = useState(
    [],
  );
  const [productionRequirementLoading, setProductionRequirementLoading] =
    useState(false);

  const [onBoarding, setOnBoarding] = useState(
    () =>
      location.state?.activeTab ||
      activeDataElement ||
      DEFAULT_ONBOARDING_TAB,
  );

  useEffect(() => {
    const routeActiveTab = location.state?.activeTab;

    if (
      routeActiveTab &&
      DATA_ELEMENTS_OPTIONS.includes(routeActiveTab)
    ) {
      setOnBoarding(routeActiveTab);
    }
  }, [location.state?.activeTab]);

  useEffect(() => {
    if (onBoarding && DATA_ELEMENTS_OPTIONS.includes(onBoarding)) {
      dispatch(setActiveDataElement(onBoarding));
    }
  }, [dispatch, onBoarding]);

  const bottlerpagination = true;
  const bottlerpaginationPageSize = 10;
  const bottlerpaginationPageSizeSelector = [5, 10, 20, 50, 100];

  const BottlerColumnDefinition = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: "supportCheckbox",
      headerName: "",
      sortable: false,
      width: 50,
      suppressSizeToFit: true,
    },
    {
      field: "bottler",
      headerName: "Bottler",
      sortable: true,
      unSortIcon: true,
      width: 270,
      minWidth: 270,
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
          },
          {
            filter: "agSetColumnFilter",
          },
        ],
      },
    },
    {
      field: "isEntitled",
      headerName: "Active",
      width: 270,
      minWidth: 270,
      sortable: true,
      sort: "desc",
      unSortIcon: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 13, marginRight: 4 }}>OFF</span>
          <BlackWhiteSwitch
            checked={params.data.isEntitled}
            onChange={async (event) => {
              const isChecked = event.target.checked;
              try {
                await ApiService.put("/v1/Onboard/updateBottlers", [
                  {
                    id: params.data.id,
                    bottler: params.data.bottler,
                    isEntitled: isChecked,
                  },
                ]);
                // fetchBottlerData();
                params.node.setDataValue("isEntitled", isChecked);
                params.api.refreshCells({
                  rowNodes: [params.node],
                  force: true,
                });
              } catch (error) {
                console.error("Error updating entitlement:", error);
                MessagePopup({
                  icon: "error",
                  title: "Error",
                  message: "Failed to update entitlement. Please try again.",
                });
              }
            }}
          />
          <span style={{ fontSize: 13, marginLeft: 4 }}>ON</span>
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Customer Country Configuration",
      width: 270,
      minWidth: 270,
      cellRenderer: (params) => {
        const isEnabled = params.data.isEntitled;

        return (
          <div>
            <EditIcon
              style={{
                cursor: isEnabled ? "pointer" : "not-allowed",
                marginRight: "10px",
                color: isEnabled ? "#000" : "#bdbdbd",
                pointerEvents: isEnabled ? "auto" : "none",
              }}
              onClick={() => isEnabled && updateBottlerForecastCountry(params)}
            />
          </div>
        );
      },
    },
    {
      field: "actions",
      headerName: "Forecast Partner Configuration",
      width: 270,
      minWidth: 270,
      cellRenderer: (params) => {
        const isEnabled = params.data.isEntitled;

        return (
          <div>
            <EditIcon
              style={{
                cursor: isEnabled ? "pointer" : "not-allowed",
                marginRight: "10px",
                color: isEnabled ? "#000" : "#bdbdbd", // blue if enabled, gray if disabled
                pointerEvents: isEnabled ? "auto" : "none",
              }}
              onClick={() => isEnabled && update(params)}
            />
          </div>
        );
      },
    },
  ];

  const MarketForecastColumnDefinition = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: "supportCheckbox",
      headerName: "",
      sortable: false,
      width: 50,
      suppressSizeToFit: true,
    },
    {
      field: "bottler",
      headerName: "Bottler",
      sortable: true,
      unSortIcon: true,
      width: 350,
      minWidth: 350,
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
          },
          {
            filter: "agSetColumnFilter",
          },
        ],
      },
    },
    {
      field: "isBottlerMarketForecast",
      headerName: "Active",
      width: 350,
      minWidth: 350,
      sortable: true,
      sort: "desc",
      unSortIcon: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 13, marginRight: 4 }}>OFF</span>
          <BlackWhiteSwitch
            checked={params.data.isBottlerMarketForecast}
            onChange={async (event) => {
              const isChecked = event.target.checked;
              try {
                await ApiService.put(
                  "/v1/market-forecast/updateBottlersForMF",
                  [
                    {
                      id: params.data.id,
                      bottler: params.data.bottler,
                      isBottlerMarketForecast: isChecked,
                    },
                  ],
                );
                // fetchMarketForecastData();
                params.node.setDataValue("isBottlerMarketForecast", isChecked);
                params.api.refreshCells({
                  rowNodes: [params.node],
                  force: true,
                });
              } catch (error) {
                console.error("Error updating market forecast:", error);
                MessagePopup({
                  icon: "error",
                  title: "Error",
                  message:
                    "Failed to update market forecast. Please try again.",
                });
              }
            }}
          />
          <span style={{ fontSize: 13, marginLeft: 4 }}>ON</span>
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Customer Country Configuration",
      width: 380,
      minWidth: 380,
      cellRenderer: (params) => {
        const isEnabled = params.data.isBottlerMarketForecast;

        return (
          <div>
            <EditIcon
              style={{
                cursor: isEnabled ? "pointer" : "not-allowed",
                marginRight: "10px",
                color: isEnabled ? "#000" : "#bdbdbd", // blue if enabled, gray if disabled
                pointerEvents: isEnabled ? "auto" : "none",
              }}
              onClick={() => isEnabled && updateMarketForecastCountry(params)}
            />
          </div>
        );
      },
    },
  ];

  const FGInventoryColumnDefinition = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: "supportCheckbox",
      headerName: "",
      sortable: false,
      width: 50,
      suppressSizeToFit: true,
    },
    {
      field: "bottler",
      headerName: "Bottler",
      sortable: true,
      unSortIcon: true,
      width: 350,
      minWidth: 350,
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
          },
          {
            filter: "agSetColumnFilter",
          },
        ],
      },
    },
    {
      field: "isFgInventory",
      headerName: "Active",
      width: 350,
      minWidth: 350,
      sortable: true,
      sort: "desc",
      unSortIcon: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 13, marginRight: 4 }}>OFF</span>
          <BlackWhiteSwitch
            checked={params.data.isFgInventory}
            onChange={async (event) => {
              const isChecked = event.target.checked;
              try {
                await ApiService.put("/v1/fg-inventory/updateBottlers", [
                  {
                    id: params.data.id,
                    bottler: params.data.bottler,
                    isFgInventory: isChecked,
                  },
                ]);
                // fetchFGInventoryData();
                params.node.setDataValue("isFgInventory", isChecked);
                params.api.refreshCells({
                  rowNodes: [params.node],
                  force: true,
                });
              } catch (error) {
                console.error("Error updating FG Inventory:", error);
                MessagePopup({
                  icon: "error",
                  title: "Error",
                  message: "Failed to update FG Inventory. Please try again.",
                });
              }
            }}
          />
          <span style={{ fontSize: 13, marginLeft: 4 }}>ON</span>
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Customer Country Configuration",
      width: 380,
      minWidth: 380,
      cellRenderer: (params) => {
        const isEnabled = params.data.isFgInventory;

        return (
          <div>
            <EditIcon
              style={{
                cursor: isEnabled ? "pointer" : "not-allowed",
                marginRight: "10px",
                color: isEnabled ? "#000" : "#bdbdbd", // blue if enabled, gray if disabled
                pointerEvents: isEnabled ? "auto" : "none",
              }}
              onClick={() => isEnabled && updateFGInventoryCountry(params)}
            />
          </div>
        );
      },
    },
  ];

  const BusinessPlanColumnDefinition = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: "supportCheckbox",
      headerName: "",
      sortable: false,
      width: 50,
      suppressSizeToFit: true,
    },
    {
      field: "bottler",
      headerName: "Bottler",
      sortable: true,
      unSortIcon: true,
      width: 350,
      minWidth: 350,
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
          },
          {
            filter: "agSetColumnFilter",
          },
        ],
      },
    },
    {
      field: "isBottlerBusinessPlan",
      headerName: "Active",
      width: 350,
      minWidth: 350,
      sortable: true,
      sort: "desc",
      unSortIcon: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 13, marginRight: 4 }}>OFF</span>
          <BlackWhiteSwitch
            checked={params.data.isBottlerBusinessPlan}
            onChange={async (event) => {
              const isChecked = event.target.checked;
              try {
                await ApiService.put("/v1/business-plan/updateBottlersForBP", [
                  {
                    id: params.data.id,
                    bottler: params.data.bottler,
                    isBottlerBusinessPlan: isChecked,
                  },
                ]);
                // fetchBusinessPlanData();
                params.node.setDataValue("isBottlerBusinessPlan", isChecked);
                params.api.refreshCells({
                  rowNodes: [params.node],
                  force: true,
                });
              } catch (error) {
                console.error("Error updating Business Plan:", error);
                MessagePopup({
                  icon: "error",
                  title: "Error",
                  message: "Failed to update Business Plan. Please try again.",
                });
              }
            }}
          />
          <span style={{ fontSize: 13, marginLeft: 4 }}>ON</span>
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Customer Country Configuration",
      width: 380,
      minWidth: 380,
      cellRenderer: (params) => {
        const isEnabled = params.data.isBottlerBusinessPlan;

        return (
          <div>
            <EditIcon
              style={{
                cursor: isEnabled ? "pointer" : "not-allowed",
                marginRight: "10px",
                color: isEnabled ? "#000" : "#bdbdbd", // blue if enabled, gray if disabled
                pointerEvents: isEnabled ? "auto" : "none",
              }}
              onClick={() => isEnabled && updateBusinessPlanCountry(params)}
            />
          </div>
        );
      },
    },
  ];

  const ConcentrateInventoryColumnDefinition = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: "supportCheckbox",
      headerName: "",
      sortable: false,
      width: 50,
      suppressSizeToFit: true,
    },
    {
      field: "bottler",
      headerName: "Bottler",
      sortable: true,
      unSortIcon: true,
      width: 350,
      minWidth: 350,
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
          },
          {
            filter: "agSetColumnFilter",
          },
        ],
      },
    },
    {
      field: "isConcentrateInventory",
      headerName: "Active",
      width: 350,
      minWidth: 350,
      sortable: true,
      sort: "desc",
      unSortIcon: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 13, marginRight: 4 }}>OFF</span>
          <BlackWhiteSwitch
            checked={params.data.isConcentrateInventory}
            onChange={async (event) => {
              const isChecked = event.target.checked;
              try {
                await ApiService.put(
                  "/v1/concentrate-inventory/updateBottlersForCI",
                  [
                    {
                      id: params.data.id,
                      bottler: params.data.bottler,
                      isConcentrateInventory: isChecked,
                    },
                  ],
                );
                // fetchConcentrateInventoryData();
                params.node.setDataValue("isConcentrateInventory", isChecked);
                params.api.refreshCells({
                  rowNodes: [params.node],
                  force: true,
                });
              } catch (error) {
                console.error("Error updating Concentrate Inventory:", error);
                MessagePopup({
                  icon: "error",
                  title: "Error",
                  message:
                    "Failed to update Concentrate Inventory. Please try again.",
                });
              }
            }}
          />
          <span style={{ fontSize: 13, marginLeft: 4 }}>ON</span>
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Customer Country Configuration",
      width: 380,
      minWidth: 380,
      cellRenderer: (params) => {
        const isEnabled = params.data.isConcentrateInventory;

        return (
          <div>
            <EditIcon
              style={{
                cursor: isEnabled ? "pointer" : "not-allowed",
                marginRight: "10px",
                color: isEnabled ? "#000" : "#bdbdbd", // blue if enabled, gray if disabled
                pointerEvents: isEnabled ? "auto" : "none",
              }}
              onClick={() => isEnabled && updateConcentrateCountry(params)}
            />
          </div>
        );
      },
    },
  ];

  const ProductionRequirementColumnDefinition = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: "supportCheckbox",
      headerName: "",
      sortable: false,
      width: 50,
      suppressSizeToFit: true,
    },
    {
      field: "bottler",
      headerName: "Bottler",
      sortable: true,
      unSortIcon: true,
      width: 350,
      minWidth: 350,
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
          },
          {
            filter: "agSetColumnFilter",
          },
        ],
      },
    },
    {
      field: "isProductRequirement",
      headerName: "Active",
      width: 350,
      minWidth: 350,
      sortable: true,
      sort: "desc",
      unSortIcon: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 13, marginRight: 4 }}>OFF</span>
          <BlackWhiteSwitch
            checked={params.data.isProductRequirement}
            onChange={async (event) => {
              const isChecked = event.target.checked;
              try {
                await ApiService.put("/v1/production-req/updateBottlersForPR", [
                  {
                    id: params.data.id,
                    bottler: params.data.bottler,
                    isProductRequirement: isChecked,
                  },
                ]);
                // fetchProductionRequirementData();
                params.node.setDataValue("isProductRequirement", isChecked);
                params.api.refreshCells({
                  rowNodes: [params.node],
                  force: true,
                });
              } catch (error) {
                console.error("Error updating Production Requirement:", error);
                MessagePopup({
                  icon: "error",
                  title: "Error",
                  message:
                    "Failed to update Production Requirement. Please try again.",
                });
              }
            }}
          />
          <span style={{ fontSize: 13, marginLeft: 4 }}>ON</span>
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Customer Country Configuration",
      width: 380,
      minWidth: 380,
      cellRenderer: (params) => {
        const isEnabled = params.data.isProductRequirement;

        return (
          <div>
            <EditIcon
              style={{
                cursor: isEnabled ? "pointer" : "not-allowed",
                marginRight: "10px",
                color: isEnabled ? "#000" : "#bdbdbd", // blue if enabled, gray if disabled
                pointerEvents: isEnabled ? "auto" : "none",
              }}
              onClick={() => isEnabled && updateproductionCountry(params)}
            />
          </div>
        );
      },
    },
  ];

  const handleSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    const combinationDetails = selectedRows.map((row) => ({
      bottler: row.bottler ?? "",
      locationName: null,
      customerName: null,
    }));

    setCombinationDetails(combinationDetails);
  };

  useEffect(() => {
    if (onBoarding === "Bottler Concentrate Forecast") {
      fetchBottlerData();
    } else if (onBoarding === "Bottler Market Forecast") {
      fetchMarketForecastData();
    } else if (onBoarding === "FG Inventory") {
      fetchFGInventoryData();
    } else if (onBoarding === "Bottler Business Plan") {
      fetchBusinessPlanData();
    } else if (onBoarding === "Concentrate Inventory") {
      fetchConcentrateInventoryData();
    } else if (onBoarding === "Production Requirement") {
      fetchProductionRequirementData();
    }
  }, [onBoarding]);

  const fetchBottlerData = async () => {
    setBottlerLoading(true);
    try {
      const response = await ApiService.get(`/v1/Onboard/getBottlers`);
      if (response.status === 200) {
        setBottlerData(response.data);
      }
    } catch (error) {
      console.error("Error fetching bottler data:", error);
    } finally {
      setBottlerLoading(false);
    }
  };

  const fetchMarketForecastData = async () => {
    setMarketForecastLoading(true);
    try {
      const response = await ApiService.get(
        `/v1/market-forecast/getBottlersForMF`,
      );
      if (response.status === 200) {
        setMarketForecastData(response.data);
      }
    } catch (error) {
      console.error("Error fetching market forecast data:", error);
      MessagePopup({
        icon: "error",
        title: "Error",
        message: "Failed to fetch Data for Market Forecast",
      });
    } finally {
      setMarketForecastLoading(false);
    }
  };

  const fetchFGInventoryData = async () => {
    setFGInventoryLoading(true);
    try {
      const response = await ApiService.get(`/v1/fg-inventory/getBottlers`);
      if (response.status === 200) {
        setFGInventoryData(response.data);
      }
    } catch (error) {
      console.error("Error fetching FG Inventory data:", error);
      MessagePopup({
        icon: "error",
        title: "Error",
        message: "Failed to fetch FG Inventory data. Please try again.",
      });
    } finally {
      setFGInventoryLoading(false);
    }
  };

  const fetchBusinessPlanData = async () => {
    setBusinessPlanLoading(true);
    try {
      const response = await ApiService.get(
        `/v1/business-plan/getBottlersForBP`,
      );
      if (response.status === 200) {
        setBusinessPlanData(response.data);
      }
    } catch (error) {
      console.error("Error fetching business plan data:", error);
      MessagePopup({
        icon: "error",
        title: "Error",
        message: "Failed to fetch Business Plan data. Please try again.",
      });
    } finally {
      setBusinessPlanLoading(false);
    }
  };

  const fetchConcentrateInventoryData = async () => {
    setConcentrateInventoryLoading(true);
    try {
      const response = await ApiService.get(
        `/v1/concentrate-inventory/getBottlersForCI`,
      );
      if (response.status === 200) {
        setConcentrateInventoryData(response.data);
      }
    } catch (error) {
      console.error("Error fetching concentrate inventory data:", error);
      MessagePopup({
        icon: "error",
        title: "Error",
        message:
          "Failed to fetch Concentrate Inventory data. Please try again.",
      });
    } finally {
      setConcentrateInventoryLoading(false);
    }
  };

  const fetchProductionRequirementData = async () => {
    setProductionRequirementLoading(true);
    try {
      const response = await ApiService.get(
        `/v1/production-req/getBottlersForPR`,
      );
      if (response.status === 200) {
        setProductionRequirementData(response.data);
      }
    } catch (error) {
      console.error("Error fetching production requirement data:", error);
      MessagePopup({
        icon: "error",
        title: "Error",
        message:
          "Failed to fetch Production Requirement data. Please try again.",
      });
    } finally {
      setProductionRequirementLoading(false);
    }
  };

  useEffect(() => {
    const resizeGrid = () => {
      if (
        onBoarding === "Bottler Concentrate Forecast" &&
        gridRef.current &&
        gridRef.current.api &&
        BottlerData.length > 0
      ) {
        gridRef.current.api.sizeColumnsToFit();
      } else if (
        onBoarding === "Bottler Market Forecast" &&
        mfGridRef.current &&
        mfGridRef.current.api &&
        marketForecastData.length > 0
      ) {
        mfGridRef.current.api.sizeColumnsToFit();
      } else if (
        onBoarding === "FG Inventory" &&
        fgGridRef.current &&
        fgGridRef.current.api &&
        fgInventoryData.length > 0
      ) {
        fgGridRef.current.api.sizeColumnsToFit();
      } else if (
        onBoarding === "Bottler Business Plan" &&
        bpGridRef.current &&
        bpGridRef.current.api &&
        businessPlanData.length > 0
      ) {
        bpGridRef.current.api.sizeColumnsToFit();
      } else if (
        onBoarding === "Concentrate Inventory" &&
        ciGridRef.current &&
        ciGridRef.current.api &&
        concentrateInventoryData.length > 0
      ) {
        ciGridRef.current.api.sizeColumnsToFit();
      } else if (
        onBoarding === "Production Requirement" &&
        prGridRef.current &&
        prGridRef.current.api &&
        productionRequirementData.length > 0
      ) {
        prGridRef.current.api.sizeColumnsToFit();
      }
    };

    resizeGrid();

    window.addEventListener("resize", resizeGrid);
    return () => window.removeEventListener("resize", resizeGrid);
  }, [
    BottlerData,
    marketForecastData,
    fgInventoryData,
    businessPlanData,
    concentrateInventoryData,
    productionRequirementData,
    onBoarding,
  ]);

  const onGrid = (params) => {
    const gridApi = params.api;
    if (gridApi) {
      gridApi.sizeColumnsToFit();
    } else {
      console.error("Grid API is not available.");
    }
  };

  const update = (params) => {
    dispatch(setSelectedBottler(params.data));
    navigate("/partner-config");
  };

  const updateBottlerForecastCountry = (params) => {
    dispatch(setSelectedBottler(params.data));
    navigate("/bf-country-config");
  };

  const updateMarketForecastCountry = (params) => {
    dispatch(setSelectedBottler(params.data));
    navigate("/mf-country-config");
  };

  const updateFGInventoryCountry = (params) => {
    dispatch(setSelectedBottler(params.data));
    navigate("/fg-country-config");
  };

  const updateBusinessPlanCountry = (params) => {
    dispatch(setSelectedBottler(params.data));
    navigate("/bp-country-config");
  };

  const updateConcentrateCountry = (params) => {
    dispatch(setSelectedBottler(params.data));
    navigate("/ci-country-config");
  };

  const updateproductionCountry = (params) => {
    dispatch(setSelectedBottler(params.data));
    navigate("/pr-country-config");
  };

  return (
    <>
      <div>
        <Grid item xs={12} sm={6} md={3} sx={{ mt: 1, mb: 1 }}>
          <Autocomplete
            disablePortal
            options={DATA_ELEMENTS_OPTIONS}
            size="small"
            value={onBoarding}
            onChange={(e, v) => {
              if (v) {
                setOnBoarding(v);
              }
            }}
            sx={{ width: 280 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Data Elements*"
                InputLabelProps={{
                  shrink: true,
                  style: {
                    transform: "translate(14px, -14px) scale(0.75)",
                  },
                }}
              />
            )}
          />
        </Grid>

        {/* Bottler Concentrate Forecast Section */}
        {onBoarding === "Bottler Concentrate Forecast" && (
          <Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="subtitle1" align="left" gutterBottom>
                Bottler Concentrate Forecast Configuration
              </Typography>
              <InfoPopover margin="0 0 3px 0" />
            </Box>
            {bottlerLoading ? (
              <Skeleton
                variant="rectangular"
                height={"70vh"}
                animation="pulse"
                style={{ marginBottom: "16px", borderRadius: "8px" }}
              />
            ) : (
              <DataTable
                ref={gridRef}
                columns={BottlerColumnDefinition}
                rows={BottlerData || []}
                tableHeight={"70vh"}
                suppressMovableColumns={true}
                suppressHorizontalScroll={false}
                suppressPaginationPanel={false}
                pagination={bottlerpagination}
                paginationPageSize={bottlerpaginationPageSize}
                paginationPageSizeSelector={bottlerpaginationPageSizeSelector}
                onGridReady={onGrid}
                rowSelection="multiple"
                onSelectionChanged={handleSelectionChanged}
              />
            )}
          </Box>
        )}

        {/* Market Forecast Section */}
        {onBoarding === "Bottler Market Forecast" && (
          <Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="subtitle1" align="left" gutterBottom>
                Bottler Market Forecast Configuration
              </Typography>
              <InfoPopover margin="0 0 3px 0" />
            </Box>
            {marketForecastLoading ? (
              <Skeleton
                variant="rectangular"
                height={"70vh"}
                animation="pulse"
                style={{ marginBottom: "16px", borderRadius: "8px" }}
              />
            ) : (
              <DataTable
                ref={mfGridRef}
                columns={MarketForecastColumnDefinition}
                rows={marketForecastData || []}
                tableHeight={"70vh"}
                suppressMovableColumns={true}
                suppressHorizontalScroll={false}
                suppressPaginationPanel={false}
                pagination={bottlerpagination}
                paginationPageSize={bottlerpaginationPageSize}
                paginationPageSizeSelector={bottlerpaginationPageSizeSelector}
                onGridReady={onGrid}
                rowSelection="multiple"
                onSelectionChanged={handleSelectionChanged}
              />
            )}
          </Box>
        )}

        {/* FG Inventory Section */}
        {onBoarding === "FG Inventory" && (
          <Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="subtitle1" align="left" gutterBottom>
                FG Inventory Configuration
              </Typography>
              <InfoPopover margin="0 0 3px 0" />
            </Box>
            {fgInventoryLoading ? (
              <Skeleton
                variant="rectangular"
                height={"70vh"}
                animation="pulse"
                style={{ marginBottom: "16px", borderRadius: "8px" }}
              />
            ) : (
              <DataTable
                ref={fgGridRef}
                columns={FGInventoryColumnDefinition}
                rows={fgInventoryData || []}
                tableHeight={"70vh"}
                suppressMovableColumns={true}
                suppressHorizontalScroll={false}
                suppressPaginationPanel={false}
                pagination={bottlerpagination}
                paginationPageSize={bottlerpaginationPageSize}
                paginationPageSizeSelector={bottlerpaginationPageSizeSelector}
                onGridReady={onGrid}
                rowSelection="multiple"
                onSelectionChanged={handleSelectionChanged}
              />
            )}
          </Box>
        )}

        {/* Business Plan Section */}
        {onBoarding === "Bottler Business Plan" && (
          <Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="subtitle1" align="left" gutterBottom>
                Bottler Business Plan Configuration
              </Typography>
              <InfoPopover margin="0 0 3px 0" />
            </Box>
            {businessPlanLoading ? (
              <Skeleton
                variant="rectangular"
                height={"70vh"}
                animation="pulse"
                style={{ marginBottom: "16px", borderRadius: "8px" }}
              />
            ) : (
              <DataTable
                ref={bpGridRef}
                columns={BusinessPlanColumnDefinition}
                rows={businessPlanData || []}
                tableHeight={"70vh"}
                suppressMovableColumns={true}
                suppressHorizontalScroll={false}
                suppressPaginationPanel={false}
                pagination={bottlerpagination}
                paginationPageSize={bottlerpaginationPageSize}
                paginationPageSizeSelector={bottlerpaginationPageSizeSelector}
                onGridReady={onGrid}
                rowSelection="multiple"
                onSelectionChanged={handleSelectionChanged}
              />
            )}
          </Box>
        )}

        {/* Concentrate Inventory Section */}
        {onBoarding === "Concentrate Inventory" && (
          <Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="subtitle1" align="left" gutterBottom>
                Concentrate Inventory Configuration
              </Typography>
              <InfoPopover margin="0 0 3px 0" />
            </Box>
            {concentrateInventoryLoading ? (
              <Skeleton
                variant="rectangular"
                height={"70vh"}
                animation="pulse"
                style={{ marginBottom: "16px", borderRadius: "8px" }}
              />
            ) : (
              <DataTable
                ref={ciGridRef}
                columns={ConcentrateInventoryColumnDefinition}
                rows={concentrateInventoryData || []}
                tableHeight={"70vh"}
                suppressMovableColumns={true}
                suppressHorizontalScroll={false}
                suppressPaginationPanel={false}
                pagination={bottlerpagination}
                paginationPageSize={bottlerpaginationPageSize}
                paginationPageSizeSelector={bottlerpaginationPageSizeSelector}
                onGridReady={onGrid}
                rowSelection="multiple"
                onSelectionChanged={handleSelectionChanged}
              />
            )}
          </Box>
        )}

        {/* Production Requirement Section */}
        {onBoarding === "Production Requirement" && (
          <Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="subtitle1" align="left" gutterBottom>
                Production Requirement Configuration
              </Typography>
              <InfoPopover margin="0 0 3px 0" />
            </Box>
            {productionRequirementLoading ? (
              <Skeleton
                variant="rectangular"
                height={"70vh"}
                animation="pulse"
                style={{ marginBottom: "16px", borderRadius: "8px" }}
              />
            ) : (
              <DataTable
                ref={prGridRef}
                columns={ProductionRequirementColumnDefinition}
                rows={productionRequirementData || []}
                tableHeight={"70vh"}
                suppressMovableColumns={true}
                suppressHorizontalScroll={false}
                suppressPaginationPanel={false}
                pagination={bottlerpagination}
                paginationPageSize={bottlerpaginationPageSize}
                paginationPageSizeSelector={bottlerpaginationPageSizeSelector}
                onGridReady={onGrid}
                rowSelection="multiple"
                onSelectionChanged={handleSelectionChanged}
              />
            )}
          </Box>
        )}
      </div>
    </>
  );
}
export default BottlerOnBoarding;
